var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"success","icon":"el-icon-download"},on:{"click":_vm.onButtonTitleButton}},[_vm._v(_vm._s(_vm.buttonTitle))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }